const globalConfig = {
    data() {
        return {
            config_BackgroundColor: "",
            config_ShowConsumtionPeriodProgram: "",
            config_ShowProgramTab: "",
            config_ShowAdTab: "",
            config_ShowChannelTab: "",
            config_ShowModelSelection: "",
            config_EnableAgeChannel4Reach: "",
            config_EnableAgeChannel4Time: "",
            config_EnableAgeProgram4Reach: "",
            config_EnableAgeProgram4Time: "",
            config_EnableAgeLimitedOnAdMeasures: "",
            config_EnableAgeLimitedChannel4Reach: "",
            config_EnableAgeLimitedProgram4Reach: "",
            config_EnableAgeLimitedProgram4Rating: "",
            config_EnableAgeLimitedProgram4Time: "",
            config_EnableAgeLimitedChannel4Time: "",
            config_EnableReachTimeProgram: "",
            config_EnableReachTimeChannel: "",
            config_EnableSexProgram: "",
            config_EnableSexAd: "",
            config_EnableSexChannel: "",
            config_EnableWeekAggChannel: "",
            config_ShowCampaignReportAd: "",
            config_ShowReachFrequencyProgram: "",
            config_ShowReachFrequencyAd: "",
            config_ShowReachFrequencyChannel: "",
            config_ShowKO8Program: "",
            config_LinkTvAnalys: "",
            config_LinkOnlineAnalys: "",
            config_LinkVideoInHome: "",
            config_LinkDataPortal: "",
            config_MiniumClientVersion: "",
            config_CurrentClientVersion: "",
            config_ApplicationHeading: "",
            config_ApplicationSubHeading: "",
            config_NumberOfTargetGroupsProgram: "",
            config_NumberOfTargetGroupsAd: "",
            config_NumberOfTargetGroupsChannel: "",
            config_WebCaatAuthWebUrl: "",
            config_MyOwnApplicationUrl: "",
            config_ShowOverview: "",
            config_NumberOfConsumptionDaysProgram: "",
            config_NumberOfConsumptionDaysAd: "",
            config_NumberOfConsumptionDaysChannel: "",
            config_NumberOfConsumptionDaysRecommendedProgram: "",
            config_NumberOfConsumptionDaysRecommendedAd: "",
            config_NumberOfConsumptionDaysRecommendedChannel: "",
            config_EnableAllChannelPicks: "",
            config_ExternalCampaignTabLink: "",
            config_ExternalProgramTabLink: "",
            config_ExternalChannelTabLink: "",
            config_OldDataUrl: "",
            config_AppCookieDomain: "",
            config_ToV3ChangeDate: "",
            config_TotalFrontendv1Url: "",
            config_AuthCookieDomain: "",
            config_ShowSaveSearchButton: "",
        }
    },
    methods: {
        async loadGlobalConfigFromFile() {
            try {
                await fetch("./config/runtime.json")
                    .then(response => {
                        return response.json()
                    })
                    .then(data => {
                        this.config_BackgroundColor = data.BackgroundColor
                        this.config_ShowConsumtionPeriodProgram = data.ShowConsumtionPeriodProgram
                        this.config_ShowProgramTab = data.ShowProgramTab
                        this.config_ShowAdTab = data.ShowAdTab
                        this.config_ShowChannelTab = data.ShowChannelTab
                        this.config_ShowModelSelection = data.ShowModelSelection
                        this.config_EnableAgeChannel4Reach = data.EnableAgeChannel4Reach
                        this.config_EnableAgeChannel4Time = data.EnableAgeChannel4Time
                        this.config_EnableAgeProgram4Reach = data.EnableAgeProgram4Reach
                        this.config_EnableAgeProgram4Time = data.EnableAgeProgram4Time
                        this.config_EnableAgeLimitedOnAdMeasures = data.EnableAgeLimitedOnAdMeasures
                        this.config_EnableAgeLimitedChannel4Reach = data.EnableAgeLimitedChannel4Reach
                        this.config_EnableAgeLimitedProgram4Reach = data.EnableAgeLimitedProgram4Reach
                        this.config_EnableAgeLimitedProgram4Rating = data.EnableAgeLimitedProgram4Rating
                        this.config_EnableAgeLimitedProgram4Time = data.EnableAgeLimitedProgram4Time
                        this.config_EnableAgeLimitedChannel4Time = data.EnableAgeLimitedChannel4Time
                        this.config_EnableReachTimeProgram = data.EnableReachTimeProgram
                        this.config_EnableReachTimeChannel = data.EnableReachTimeChannel
                        this.config_EnableSexProgram = data.EnableSexProgram
                        this.config_EnableSexAd = data.EnableSexAd
                        this.config_EnableSexChannel = data.EnableSexChannel
                        this.config_EnableWeekAggChannel = data.EnableWeekAggChannel
                        this.config_ShowCampaignReportAd = data.ShowCampaignReportAd
                        this.config_ShowReachFrequencyProgram = data.ShowReachFrequencyProgram
                        this.config_ShowReachFrequencyAd = data.ShowReachFrequencyAd
                        this.config_ShowReachFrequencyChannel = data.ShowReachFrequencyChannel
                        this.config_ShowKO8Program = data.ShowKO8Program
                        this.config_LinkTvAnalys = data.LinkTvAnalys
                        this.config_LinkOnlineAnalys = data.LinkOnlineAnalys
                        this.config_LinkVideoInHome = data.LinkVideoInHome
                        this.config_LinkDataPortal = data.LinkDataPortal
                        this.config_MiniumClientVersion = data.MiniumClientVersion
                        this.config_CurrentClientVersion = data.CurrentClientVersion
                        this.config_ApplicationHeading = data.ApplicationHeading
                        this.config_ApplicationSubHeading = data.ApplicationSubHeading
                        this.config_NumberOfTargetGroupsProgram = data.NumberOfTargetGroupsProgram
                        this.config_NumberOfTargetGroupsAd = data.NumberOfTargetGroupsAd
                        this.config_NumberOfTargetGroupsChannel = data.NumberOfTargetGroupsChannel
                        this.config_WebCaatAuthWebUrl = data.WebCaatAuthWebUrl
                        this.config_MyOwnApplicationUrl = data.MyOwnApplicationUrl
                        this.config_ShowOverview = data.ShowOverview
                        this.config_NumberOfConsumptionDaysProgram = data.NumberOfConsumptionDaysProgram
                        this.config_NumberOfConsumptionDaysAd = data.NumberOfConsumptionDaysAd
                        this.config_NumberOfConsumptionDaysChannel = data.NumberOfConsumptionDaysChannel
                        this.config_NumberOfConsumptionDaysRecommendedProgram = data.NumberOfConsumptionDaysRecommendedProgram
                        this.config_NumberOfConsumptionDaysRecommendedAd = data.NumberOfConsumptionDaysRecommendedAd
                        this.config_NumberOfConsumptionDaysRecommendedChannel = data.NumberOfConsumptionDaysRecommendedChannel
                        this.config_EnableAllChannelPicks = data.EnableAllChannelPicks
                        this.config_ExternalCampaignTabLink = data.ExternalCampaignTabLink
                        this.config_ExternalProgramTabLink = data.ExternalProgramTabLink
                        this.config_ExternalChannelTabLink = data.ExternalChannelTabLink
                        this.config_OldDataUrl = data.OldDataUrl
                        this.config_AppCookieDomain = data.AppCookieDomain
                        this.config_ToV3ChangeDate = data.ToV3ChangeDate
                        this.config_TotalFrontendv1Url = data.TotalFrontendv1Url
                        this.config_AuthCookieDomain = data.AuthCookieDomain
                        this.config_ShowSaveSearchButton = data.ShowSaveSearchButton
                    })
                    .catch(error => {
                        console.error(error)
                    })
            } catch (error) {
                console.error(error)
            }
        },
    },
}

export default globalConfig
